import React from "react";

interface Practitioner {
  name: string;
}

interface Item {
  drugs_name: string;
}

interface Summary {
  practitioner: Practitioner;
  specialty: string;
  reference_date: string;
  hospital_portal_name: string;
  doctor_note: string;
  poly: string;
  speciality_name: string;
  plan: string;
  file_url: string;
  items: Item[]; 
}

const Reference: React.FC<{ summary: Summary }> = ({ summary }) => {
  return (
    <div
      style={{
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#eaf4ff",
        fontSize: "12px",
        // fontFamily: "Arial, sans-serif",
        // width: "100%", // Lebar penuh
        boxSizing: "border-box", // Pastikan padding tidak menambah lebar elemen
      }}
    >
      <p style={{ margin: "0 0 10px", color: "#00bfa5", textAlign:"center" }}><b>Consultation Reference</b></p>
      <hr style={{ border: "none", borderTop: "1px solid #ddd" }}  />
      <table>
        <tr>
          <td>Doctor</td>
          <td>:</td>
          <td>{summary.practitioner?.name || "N/A"}</td>
        </tr>
        <tr>
          <td>Date</td>
          <td>:</td>
          <td>{summary.reference_date || "N/A"}</td>
        </tr>
      </table>
     
      <hr style={{ border: "none", borderTop: "1px solid #ddd" }} />
      <table>
          <tr>
            <td> Provider</td>
            <td> : </td>
            <td> {summary.hospital_portal_name || "N/A"}</td>
          </tr>
          <tr>
            <td> {summary.speciality_name ? 'Spesialisasi' : 'Poly'}</td>
            <td> : </td>
            <td> {summary.speciality_name || summary.poly || "N/A"}</td>
          </tr>
          <tr>
            <td> Notes</td>
            <td> : </td>
            <td> {summary.doctor_note || "N/A"}</td>
          </tr>
          <tr>
            <td> Download</td>
            <td> : </td>
            <td> 
              {summary.file_url ? (
                <a
                  style={{ textDecoration: "none", color: "blue" }}
                  href={summary.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Rujukan
                </a>
              ) : (
                "N/A"
              )}
            </td>
          </tr>
      </table>
    </div>
  );
};

export default Reference;
